<template>
  <div>
    <el-row class="loginHeader">
      <el-col :span="24">
        <img src="../assets/login/logo.png" style="width: 80px; height: 50px;"/>
      </el-col>
    </el-row>
    <el-row class="loginMain">
      <el-col :span="12">&nbsp;</el-col>
      <el-col :span="12">
        <login class="login" v-on:loginSuccess="loginSuccess"></login>
      </el-col>
    </el-row>
    <el-row class="loginFooter">
      <el-col :span="24">
        <el-row>
          <el-col :span="24">
            <p>
              <a href="mailto:pr@daanhealth.com">pr@yunkanghealth.com</a>广东省广州市黄埔区科学城荔枝山路6号云康集团总部 /
              广东省广州市越秀区东风东路中山大学北校区北门云康服务中心
            </p>
            <p><a href="http://www.yunkanghealth.com">www.yunkanghealth.com</a> ©
              <span id="years"></span>
              版权所有： 云康
            </p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <ul class="erweima">
              <li>
                <img src="../assets/login/erweima1.jpg" /><br/>
                <span>云康公众号</span>
              </li>
              <li>
                <img src="../assets/login/erweima2.jpg" /><br/>
                <span>达安临检公众号</span>
              </li>
            </ul>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import Login from '@/components/Login.vue'
  import {keyCodes} from '../commons'

  export default {
    data() {
      return {}
    },
    props: {},
    computed: {},
    components: {
      Login
    },
    methods: {
      /**
       * 登陆成功后回调
       */
      loginSuccess(){
        const _this = this;
        _this.$store.dispatch('setLoginBy',keyCodes.LOGIN_BY_COMMON)
      }
    },
    watch: {},
    mounted(){
      $('#years').text(new Date().getFullYear());
    }
  }
</script>

<style scoped lang="scss">
  .login {
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    margin: 10px auto;
  }

  .loginHeader {
    height: 120px;
    line-height: 120px;
    padding: 0px 60px 0px 60px;
  }

  .loginMain {
    background: url("../assets/login/banner1.jpg") no-repeat;
  }

  .loginFooter {
    text-align: center;
    font-size: 14px;
  }
  .erweima {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    li {
      list-style: none;
      /*position: relative;*/
      /*float: left;*/
      font-size:12px;
      margin: 0 10px;
      img {
        width: 66px;
        height: 66px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/LoginCommon.vue